function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($helpers) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-progress-bar-container': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "style": {
            'width': `${$helpers.getPercentStatus()}%`
          },
          "class": {
            'mp-progress-bar-status': true
          },
        }));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;